const logger = {
	// eslint-disable-next-line
	log: (...message) => console.log(...message),
	// eslint-disable-next-line
	warn: (...message) => console.warn(...message),
	// eslint-disable-next-line
	error: (...message) => console.error(...message),
};

export default logger;
